var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-g01-icon-ranking"},[(_vm.isTop3)?_c('IconBase',{attrs:{"width":32,"height":37,"view-box":"0 0 32 37"}},[_c(_vm.icon,{tag:"component"})],1):_c(_vm.icon,{tag:"component",attrs:{"num":_vm.num}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }